export default __webpack_public_path__ + "static/media/Rocket_2.2e069c58.png";